/**
 * Adjusts the current page after deletion to prevent showing empty pages
 *
 * @param {number} currentPage - Current page number (0-indexed)
 * @param {number} totalCount - Total number of items after deletion
 * @param {number} rowsPerPage - Number of rows per page
 * @param {function} setPage - Function to update the page state
 * @returns {number} - The adjusted page number
 */
export const adjustPageAfterDeletion = (currentPage, totalCount, rowsPerPage, setPage) => {
  // Calculate total pages after deletion
  const totalPages = Math.ceil(totalCount / rowsPerPage);

  // If no items left, stay on page 0
  if (totalCount === 0) {
    if (currentPage !== 0) {
      setPage(0);
    }
    return 0;
  }

  // If current page is beyond the last page, move to the last page
  if (currentPage >= totalPages) {
    const newPage = Math.max(0, totalPages - 1);
    setPage(newPage);
    return newPage;
  }

  return currentPage;
};
